import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { PayrollCalendarRequest } from '../payrollCalendar.types';

const createPayrollCalendar = (request: PayrollCalendarRequest) => {
  return api.post(API_URL.PAYROLL_CALENDARS, request);
};

const useCreatePayrollCalendarQuery = () => {
  const { mutateAsync, isLoading } = useMutation((request: PayrollCalendarRequest) =>
    createPayrollCalendar(request)
  );

  const createCalendar = useCallback(
    async (params: PayrollCalendarRequest) => {
      await mutateAsync(params);
    },
    [mutateAsync]
  );

  return {
    createCalendar,
    isLoading,
  };
};

export default useCreatePayrollCalendarQuery;
